import axiosInstance from "./axiosInstance"

import type { Response } from './axiosInstance'

export enum MqSignEnum {
    CONTROL = "0",
    MESSAGE = "1"
}

export const getPty = async (): Promise<Response<{ pid?: string }>> => {
    try {
        const res = await axiosInstance.get<Response<{ pid?: string }>>(`/pty/`, {
            withCredentials: true,
        })
        return res.data
    } catch (e: any) {
        return { ok: false, message: e?.response?.data.message, data: {} }
    }
}

export const wsUrl = (() => {
    if (!import.meta.env.VITE_API_URL) return undefined;
    
    let url = import.meta.env.VITE_API_URL + "/";
    
    // Check if the URL already starts with http:// or https://
    if (!url.startsWith("http://") && !url.startsWith("https://")) {
        // Get the current location (host)
        const protocol = window.location.protocol;
        const host = window.location.host;
        url = `${protocol}//${host}${url.startsWith("/") ? url : "/" + url}`;
    }
    
    return url;
})();